export function suggestFullNameFromNames(firstName, lastName) {
  return [firstName, lastName].filter(Boolean).join(' ').trim();
}

export function suggestUsernameFromNames(firstName, lastName) {
  const parts = [firstName, lastName]
    .filter(Boolean)
    .map((part) =>
      part
        .normalize('NFKD')
        .replace(/\p{M}/gu, '')
        .toLowerCase(),
    );

  let username = parts
    .join('_')
    .replace(/[^a-z0-9_]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');

  if (username.length < 3) {
    username = (username || 'closet').padEnd(3, 'x').slice(0, 30);
  }

  return username.slice(0, 30);
}

export function applySuggestedProfileFields(prev, firstName, lastName, touched) {
  const next = { ...prev, first_name: firstName, last_name: lastName };

  if (!touched.fullName) {
    next.full_name = suggestFullNameFromNames(firstName, lastName);
  }
  if (!touched.username) {
    next.username = suggestUsernameFromNames(firstName, lastName);
  }

  return next;
}
